module.exports = __webpack_public_path__ + "img/company_5.4d8c0aa6.jpg";